import React from "react";
import { EditIcon } from "../assets/Icons";

const ChannelDetails = ({ details, openEditChannelModal }) => {
  return (
    <>
      <div className="col-12">
        <div className="application-main mt-3">
          <span className="application-logo">
            {details?.img ? (
              <img src={details?.img} />
            ) : (
              <img src={details?.group?.avatar || "https://cdn.simulanis.io/sso/logos/default_simulanis.png"} />
            )}
          </span>
          <div className="details-here">
            <span className="name-des">
              <span className="d-flex gap-1 mb-1 align-items-center justify-content-start">
                <h6 className="m-0">Name: {details?.name || ""} </h6>
                <span className="actionbtns ms-1">
                  <button onClick={openEditChannelModal}>
                    <EditIcon />
                  </button>
                </span>
              </span>
            </span>
            <span className="important-info">
              {details?.group && (
                <p>
                  Group: <span> {details?.group?.name || ""} </span>
                </p>
              )}
              <p>
                Directory: <span> {details?.directory?.name || ""} </span>
              </p>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChannelDetails;
